export default __webpack_public_path__ + "static/media/ARESS.3c890ca4.png";